import styled from 'styled-components';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: space-around;
  padding: 30px 25px;
  background-color: ${(props) => props.theme.color.neutral.v100};
  text-align: center;
  font-weight: 700;
  font-size: 20px;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 35px 80px 60px;
  }
`;

const CautionImage = styled.img`
  padding: 0 0 10px 0;
  width: 50px;
`;

const ModalTitle = styled.div`
  ${(props) => props.theme.font.heading.v100};
`;

const ModalMessage = styled.div`
  color: ${(props) => props.theme.color.neutral.v500};
  padding-top: 20px;
  text-align: center;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  ${(props) => props.theme.font.body.v300};

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    ${(props) => props.theme.font.body.v200};
  }
`;

export { ModalTitle, ModalContent, ModalMessage, CautionImage };
